import React, { useState } from 'react'
import { Inertia } from '@inertiajs/inertia'
import Layout from '../../Shared/Layout/LayoutAdmin'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Breadcrumbs from '../../Shared/Components/Breadcrumbs'
import './org-chart.css'

const NEUTRAL_AVATAR = '/metronic/assets/media/avatars/blank.png'

function OrgNode({ node, canEdit, depth = 0 }) {
    const [expanded, setExpanded] = useState(depth < 2)
    const hasChildren = (node.children || []).length > 0

    function openEdit() {
        if (!canEdit) {
            return
        }
        if (node.type === 'employee') {
            Inertia.visit(route('employees.edit', node.id))
            return
        }
        Inertia.visit(route('advisers.edit', node.id))
    }

    function toggle(e) {
        e.stopPropagation()
        setExpanded((v) => !v)
    }

    return (
        <li>
            <div
                className={[
                    'org-chart-card',
                    canEdit ? 'is-clickable' : '',
                    hasChildren ? 'has-toggle' : '',
                ].filter(Boolean).join(' ')}
                onClick={canEdit ? openEdit : undefined}
                role={canEdit ? 'button' : undefined}
                onKeyDown={canEdit ? (e) => { if (e.key === 'Enter') openEdit() } : undefined}
                tabIndex={canEdit ? 0 : undefined}
            >
                <img
                    className="org-chart-avatar"
                    src={node.photo_url || NEUTRAL_AVATAR}
                    alt=""
                    width={56}
                    height={56}
                    onError={(e) => {
                        if (e.currentTarget.src !== NEUTRAL_AVATAR) {
                            e.currentTarget.src = NEUTRAL_AVATAR
                        }
                    }}
                />
                <div className="org-chart-name">{node.name || '—'}</div>
                <div className="org-chart-position">{node.position || '—'}</div>
                <div className="org-chart-office">{node.office || '—'}</div>
                {canEdit && (
                    <div className="org-chart-hint">Clic para editar</div>
                )}
                {hasChildren && (
                    <button
                        type="button"
                        className="org-chart-toggle"
                        onClick={toggle}
                        aria-label={expanded ? 'Colapsar' : 'Expandir'}
                        aria-expanded={expanded}
                    >
                        {expanded ? '−' : '+'}
                    </button>
                )}
            </div>
            {hasChildren && expanded && (
                <ul>
                    {node.children.map((child) => (
                        <OrgNode key={child.id} node={child} canEdit={canEdit} depth={depth + 1} />
                    ))}
                </ul>
            )}
        </li>
    )
}

const Index = ({ tree = [], canEdit = false }) => {
    return (
        <Row>
            <div className="mb-7 mt-7">
                <Breadcrumbs currentPath="/admin/corporate_structure/org-chart" />
            </div>

            <Col className="mt-4 mb-2 px-1">
                <h2>Organigrama</h2>
                <p className="text-gray-600 mb-0">
                    Vista jerárquica del personal activo según el campo Líder.
                    Quienes no tienen líder válido aparecen en la rama superior.
                    {canEdit ? ' Con permiso de edición, haz clic en una persona para abrir su ficha.' : ''}
                </p>
            </Col>

            <Col xs={12} className="mt-4">
                <div className="card card-flush">
                    <div className="card-body">
                        {tree.length === 0 ? (
                            <p className="text-center text-gray-600 mb-0">No hay personal activo para mostrar.</p>
                        ) : (
                            <div className="org-chart-wrap">
                                <div className="org-chart">
                                    <ul>
                                        {tree.map((node) => (
                                            <OrgNode key={node.id} node={node} canEdit={canEdit} />
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Col>
        </Row>
    )
}

Index.layout = (page) => <Layout children={page} title="Organigrama" />

export default Index
